import Form from './Form';
export default Form;


//////////////////
// WEBPACK FOOTER
// /Users/shuai/Documents/github/ant-design-pro-site/scaffold/node_modules/_antd@3.15.2@antd/es/form/index.js
// module id = 643
// module chunks = 0